import { el, setText, setStyle } from './util.js';

/** Compact, always-visible proof of progression while a fight is active. */
export class ProgressionBadge {
  constructor(parent) {
    this.root = el('div', 'ow-progression', parent);
    const crest = el('div', 'ow-prog-level', this.root);
    el('span', null, crest, 'LVL');
    this.level = el('b', null, crest, '1');
    const body = el('div', 'ow-prog-body', this.root);
    this.label = el('div', 'ow-prog-label', body, 'COMBAT LEVEL');
    const track = el('div', 'ow-prog-track', body);
    this.fill = el('i', null, track);
    this.xp = el('div', 'ow-prog-xp', body, '0 / 1,000 XP');
    this._level = -1;
    this._current = -1;
    this._next = -1;
    this._progress = -1;
    this._xpText = '';
  }

  update(state) {
    const level = Math.max(1, state?.level | 0);
    const current = Math.max(0, state?.current | 0);
    const next = Math.max(1, state?.next | 0);
    if (this._level !== level) {
      this._level = level;
      setText(this.level, level);
    }
    if (this._current !== current || this._next !== next) {
      this._current = current;
      this._next = next;
      const xpText = `${current.toLocaleString()} / ${next.toLocaleString()} XP`;
      this._xpText = xpText;
      setText(this.xp, xpText);
    }
    const progress = Math.min(1, current / next);
    if (Math.abs(progress - this._progress) > 0.00001) {
      this._progress = progress;
      setStyle(this.fill, 'transform', `scaleX(${progress.toFixed(4)})`);
    }
  }

  dispose() {
    this.root.remove();
  }
}
